(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["didigift-series-banners"] && !Shopify.designMode) return;
  try {
    
  class DidiGiftSeriesBanners extends HTMLElement {
    connectedCallback() {
      if (this.dataset.carouselReady === 'true') return;

      this.dataset.carouselReady = 'true';
      this.track = this.querySelector('.didigift-series-banners__track');
      this.slides = Array.from(this.querySelectorAll('.didigift-series-banners__slide'));
      this.storyTrack = this.querySelector('[data-story-track]');
      this.storySlides = Array.from(this.querySelectorAll('[data-story-slide]'));
      this.storyViewport = this.querySelector('[data-story-viewport]');
      this.dots = Array.from(this.querySelectorAll('[data-carousel-dot]'));
      this.status = this.querySelector('[data-carousel-status]');
      this.currentIndex = 0;

      if (!this.track || this.slides.length === 0) return;

      this.showSlide(0, false);

      if (this.slides.length < 2) return;

      this.querySelector('[data-carousel-previous]')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex - 1);
      });

      this.querySelector('[data-carousel-next]')?.addEventListener('click', () => {
        this.showSlide(this.currentIndex + 1);
      });

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          this.showSlide(Number(dot.dataset.carouselDot));
        });
      });

      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.showSlide(this.currentIndex - 1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.showSlide(this.currentIndex + 1);
        }
      });

      let touchStartX = null;
      this.addEventListener('touchstart', (event) => {
        touchStartX = event.changedTouches[0]?.clientX ?? null;
      }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (touchStartX === null) return;
        const distance = (event.changedTouches[0]?.clientX ?? touchStartX) - touchStartX;
        if (Math.abs(distance) > 45) {
          this.showSlide(this.currentIndex + (distance < 0 ? 1 : -1));
        }
        touchStartX = null;
      }, { passive: true });

      this.addEventListener('shopify:block:select', (event) => {
        const selectedSlide = event.target.closest('.didigift-series-banners__slide');
        if (selectedSlide) this.showSlide(Number(selectedSlide.dataset.slideIndex), false);
      });
    }

    showSlide(nextIndex, announce = true) {
      const total = this.slides.length;
      this.currentIndex = (nextIndex + total) % total;
      this.track.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      if (this.storyTrack) {
        this.storyTrack.style.transform = `translateX(-${this.currentIndex * 100}%)`;
      }

      this.slides.forEach((slide, index) => {
        const isActive = index === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('a, button').forEach((control) => {
          control.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      });

      this.storySlides.forEach((slide, index) => {
        const isActive = index === this.currentIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', String(!isActive));
        slide.querySelectorAll('a, button').forEach((control) => {
          control.setAttribute('tabindex', isActive ? '0' : '-1');
        });
      });

      const activeSlide = this.slides[this.currentIndex];
      const hasStory = activeSlide?.dataset.hasStory === 'true';
      if (this.storyViewport) this.storyViewport.hidden = !hasStory;

      this.dots.forEach((dot, index) => {
        const isActive = index === this.currentIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', String(isActive));
      });

      if (announce && this.status) {
        this.status.textContent = `Banner ${this.currentIndex + 1} of ${total}`;
      }
    }
  }

  if (!customElements.get('didigift-series-banners')) {
    customElements.define('didigift-series-banners', DidiGiftSeriesBanners);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
